var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmailForm',{attrs:{"duplicatecode":_vm.duplicatecode,"submitted":_vm.submitted},on:{"FormUpdate":_vm.FormUpdate,"onSubmit":function($event){_vm.onSubmit($event)},"redirectPage":_vm.redirectPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }